import React from 'react'
import QuestionsBlock from '../../questions-block'
import {useAppSelector} from "~/hooks/redux";
import {priceService} from "~/store/price/price-service";
import { IPrice } from "~/types/IPrice";
import {ICountryItem} from "~/types/ICountryItem";
import { dividedByThree } from "~helpers/constant";

interface IQuestions {
  header: string,
  description: string | React.ReactNode
}

interface ICurrency {
  [key: string]: string;
}

export const Questions: React.FC = () => {
  return (
    <div className='onlinepbx__help__question'>
      <div className='onlinepbx__container'>
        <h2 className='onlinepbx__content__header__center'>
          Вопросы и ответы
        </h2>
        {QuestionsBlock(getQuestions())}
      </div>
    </div>
  )
}

const getQuestions = (): IQuestions[] => {
  const { country } = useAppSelector(state => state.countryReducer);
  const { data: services, isLoading } = priceService.useGetPricesQuery('');

  const getServicePrice = (type: string) => {
    return services?.find((service: IPrice) => service.type === type)
  }

  const currencyObj: ICurrency = {
    RU: 'рублей',
    UZ: 'сум',
    KZ: 'тенге',
  };

  const getPrice = (type: string, services: IPrice[], selectedCountry: ICountryItem, isLegalPerson: boolean) => {
    const service = services?.find((service) => service.type === type);
    const cost = service?.cost_in_currency_per_day.find((item) =>
        item.currency === ((isLegalPerson ? 'RUB' : selectedCountry?.currency)));
    return Math.round(cost?.cost/100 * service?.step_period_count)
  }

  const priceUserModule: number = getPrice('USER', services, country, false)

  return [{
    header: 'Сколько стоит onlinePBX?',
    description: <div className='onlinepbx__question__description'>
      <div className='onlinepbx__question__description__line'>
        {'Стоимость сервиса складывается из набора используемых услуг и их количества. Каждый сотрудник (пользователь) стоит ' + dividedByThree(priceUserModule, ' ') + ' ' + currencyObj[country?.value] + ' в месяц.'}
      </div>
      <div className='onlinepbx__question__description__line'>
        После регистрации действует пробный период 7 дней, когда все услуги бесплатны. Протестируйте сервис, качество связи и работу нашей техподдержки, определите набор услуг и их стоимость.
      </div>
      <div className='onlinepbx__question__description__line'>
        Обратите внимание: за минуты разговора вы платите оператору связи.
      </div>
    </div>
  }, {
    header: 'С какими операторами вы работаете и кого мне выбрать?',
    description: <div className='onlinepbx__question__description'>
      Подключите существующий номер или приобретите новый у наших партнеров. У нас есть опыт работы с 200 операторами. Весь список в
      <a
        href='https://onlinepbx.evateam.ru/docs/docs/DOC-000047#operatory-svyazi'
        target='_blank'
        className='onlinepbx__question__description__link'>
        базе знаний
      </a>.
      После регистрации вы можете приобрести новый номер у нашего парнёра VoxImplant.
    </div>
  }, {
    header: 'Как подключить виртуальную АТС?',
    description: <div className='onlinepbx__question__description'>
      Подключите виртуальную АТС в три этапа: зарегистрируйте и настройте АТС, интегрируйте CRM-систему, подключите и настройте рабочие места — <span className='onlinepbx__question__description__wrap'>IP-телефоны</span> или гарнитуры. Удалённая поддержка настроит АТС за вас, чтобы сэкономить время — это займёт от 20 минут до нескольких часов. Либо настройте самостоятельно при помощи инструкции<a
        target='_blank'
        className='onlinepbx__question__description__link'
        href='https://onlinepbx.evateam.ru/docs/docs/CmfDocument:1bdc44d6-48aa-11ee-848f-00161e050156#bystryj-start-v-online-pbx'>Как начать работу</a>.
    </div>
  }, {
    header: 'Подойдёт ли моё оборудование?',
    description: <div className='onlinepbx__question__description'>
      <div className='onlinepbx__question__description__line'>
        Большинство IP-телефонов и гарнитур поддерживается нашим сервисом, полного списка нет.
      </div>
      <div className='onlinepbx__question__description__line'>
        Рекомендуемые модели мы описали в
        <a
          target='_blank'
          href='https://onlinepbx.evateam.ru/docs/docs/DOC-000061#oborudovanie'
          className='onlinepbx__question__description__link'>
          базе знаний
        </a>. Предупреждаем, что могут возникнуть сложности со следующим оборудованием: роутеры Zyxel, телефоны <span className='onlinepbx__question__description__wrap'>D-Link</span>, GSM-шлюзы, устройства Yota, 3G-модемы и VOIP-шлюзы (кроме Cisco). Для стабильного соединения рекомендуемый проводной интернет, так как по WiFi могут возникать искажения.
      </div>

    </div>
  }]
}

export default Questions
